module.exports = __webpack_public_path__ + "fonts/GillSansStd-Light.woff";


//////////////////
// WEBPACK FOOTER
// ./apps/assets/fonts/GillSansStd-Light.woff
// module id = 87
// module chunks = 0